import type { CustomAgentJsonType } from '@bb/domain/dist/types/CustomAgent';
import axios, { type AxiosRequestConfig } from 'axios';

const save = async (
  customAgent: Omit<
    CustomAgentJsonType,
    | '_id'
    | 'id'
    | 'createdBy'
    | 'createdByRole'
    | 'org'
    | 'isDeleted'
    | 'location'
    | 'updatedBy'
    | 'team'
  >,
) => {
  const config: AxiosRequestConfig = {
    url: '/custom_agent',
    method: 'post',
    data: customAgent,
  };

  const { data } = await axios.request<CustomAgentJsonType>(config);
  return data;
};
export default save;
